'use client'
import { useSyncExternalStore } from 'react'
const subscribe = () => () => {}
/** Prevent native submissions before the client form has hydrated. */
export function useFormReady() { return useSyncExternalStore(subscribe, () => true, () => false) }
